import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CustomersPage from "./pages/CustomersPage";
import UsersPage from "./pages/UsersPage";
import OrdersPage from "./pages/OrdersPage";
import MainLayout from "./components/Layout/MainLayout";
import { AuthProvider } from "./store/AuthContext";
import './i18n';
import ProtectedRoute from "./routes/ProtectedRoute";
import CitiesPage from "./pages/CityPage";
import RolePage from "./pages/RolePage";
import OrderStatusPage from "./pages/OrderStatusPage";
import ProfilePage from "./pages/ProfilePage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getDirection } from "./utils/i18n";
import { ConfigProvider } from "antd";
import PrintInvoicePage from "./pages/PrintInvoicePage";
import Report from "./components/Report/Report";

const BRAND_ORANGE = "#DF5515";
const BRAND_PURPLE = "#27156B";

const theme = {
  token: {
    colorPrimary: BRAND_ORANGE,
    colorLink: BRAND_ORANGE,
    colorLinkActive: BRAND_ORANGE,
    colorLinkHover: "#e75d17",
    // Optional: apply background if you want, e.g. sidebar or card
    // colorBgContainer: BRAND_PURPLE,
  },
  components: {
    Button: {
      borderRadius: 8,
      fontWeight: 600,
      colorPrimary: BRAND_ORANGE,
      colorPrimaryHover: "#e75d17",
      colorPrimaryActive: "#bd440f",
    }
    // You can customize more AntD components here if you want
  }
};

const App: React.FC = () => {
  const { i18n } = useTranslation();
  const direction = getDirection(i18n.language);

  useEffect(() => {
    document.documentElement.setAttribute('dir', direction);
  }, [direction]);

  return (
    <ConfigProvider direction={direction} theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="customers" element={<ProtectedRoute><CustomersPage /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
              <Route path="orders/new" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
              <Route path="city" element={<ProtectedRoute><CitiesPage /></ProtectedRoute>} />
              <Route path="roles" element={<ProtectedRoute><RolePage /></ProtectedRoute>} />
              <Route path="orders/status/:status" element={<ProtectedRoute><OrderStatusPage /></ProtectedRoute>} />
              <Route path="profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/print-invoice" element={<PrintInvoicePage />} />
              <Route path="/report" element={<Report />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
